import { render } from "./Pago.vue?vue&type=template&id=45a3652c&scoped=true"
import script from "./Pago.vue?vue&type=script&lang=js"
export * from "./Pago.vue?vue&type=script&lang=js"

import "./Pago.vue?vue&type=style&index=0&id=45a3652c&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a3652c"]])

export default __exports__